import React from 'react';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ProductionNotifications = ({ notifications, onDismiss }) => {
    if (notifications.length === 0) return null;

    return (
        <Alert variant="success" className="mb-3" dismissible onClose={onDismiss}>
            <Alert.Heading>
                <i className="fas fa-bell me-2"></i>
                Production Updates ({notifications.length})
            </Alert.Heading>
            {notifications.map(notif => (
                <div key={notif.id} className="d-flex justify-content-between align-items-center border-bottom py-2">
                    <div>
                        <strong>{notif.message}</strong>
                        <div className="text-muted small">
                            Production batch completed and ready for dispatch
                        </div>
                    </div>
                    <div>
                        <Link 
                            to={`/sales-orders/${notif.orderId}`} 
                            className="btn btn-sm btn-outline-primary me-2"
                        >
                            View Order
                        </Link>
                        <Link 
                            to={`/batch/${notif.batchId}`} 
                            className="btn btn-sm btn-outline-info"
                        >
                            View Batch
                        </Link>
                    </div>
                </div>
            ))}
        </Alert>
    );
};

export default ProductionNotifications;